import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DevicePixelRatio from './utils/devicePixelRatio'
  import zh from 'element-plus/dist/locale/zh-cn.mjs';
  import zhTw from 'element-plus/dist/locale/zh-tw.mjs';
  import en from 'element-plus/dist/locale/en.mjs';
  import { defineComponent, ref, nextTick, provide, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const appStore = useStore();

  const computedLocale = computed(() => {
    switch (appStore.state.language) {
      case 'zh':
        return zh;
      case 'zhTw':
        return zhTw;
      case 'en':
        return en;
      default:
        return zh;
    }
  });
  const isRouterAlive = ref(true);
  const reload = () => {
    isRouterAlive.value = false;
    nextTick(() => {
      isRouterAlive.value = true;
    });
  };
  provide("reload", reload);
  // new DevicePixelRatio().init()
  const router = useRouter();
  const store = useStore();
  onMounted(() => {
  store.commit("changeNowClientWidth", document.documentElement.clientWidth);
  // console.log("store.state.curRoute", sessionStorage.getItem("curRoute"));
  // 监听视图宽度的变化
  window.addEventListener("load", function () {
    // 防止刷新的时候路由丢失
    // sessionStorage.getItem("curRoute") &&
    //   router.push(sessionStorage.getItem("curRoute"));
    window.addEventListener("resize", function () {
      store.commit(
        "changeNowClientWidth",
        document.documentElement.clientWidth
      );
    });
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _unref(computedLocale) }, {
    default: _withCtx(() => [
      (isRouterAlive.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})